export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ұсыныстар"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Менің мәмілелерім"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Менің жарнамаларым"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мәмілелер"])}
}